import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import { Button, Grid2, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { zoullooColors } from "../../../../../theme";
import { AvailabilityViewModel } from "../../../../../ViewModels/FreelancerOnboardingMyAvailabilityStepViewModel";

interface AvailabilitySelectorProps {
	readonly selectedAvailability: AvailabilityViewModel | null;
	readonly onAvailabilitySelect: (availability: AvailabilityViewModel) => void;
	readonly touched: boolean;
	readonly error: string | undefined;
}

export default function AvailabilitySelector({
	selectedAvailability,
	onAvailabilitySelect,
	touched,
	error
}: AvailabilitySelectorProps) {
	const { t } = useTranslation();

	return (
		<Grid2 container spacing={2} sx={{ mb: 3 }}>
			{/* Available Button */}
			<Grid2 size={{ xs: 12, md: 3 }}>
				<Button
					startIcon={<HowToRegOutlinedIcon />}
					onClick={() => onAvailabilitySelect("available")}
					variant="outlined"
					size="large"
					disableRipple
					fullWidth
					sx={{
						height: "60px",
						color: zoullooColors.grey[700],
						borderColor:
							selectedAvailability === "available"
								? zoullooColors.success?.main || "#4caf50"
								: zoullooColors.grey[400],
						borderWidth: selectedAvailability === "available" ? 2 : 1,
						"&:hover": {
							borderColor:
								selectedAvailability === "available"
									? zoullooColors.success?.main || "#4caf50"
									: zoullooColors.grey[700],
							backgroundColor: zoullooColors.grey[100]
						}
					}}
				>
					{t("freelancerOnboardingMyAvailability.available")}
				</Button>
			</Grid2>

			{/* On Mission Button */}
			<Grid2 size={{ xs: 12, md: 3 }}>
				<Button
					startIcon={<BusinessCenterOutlinedIcon />}
					onClick={() => onAvailabilitySelect("onMission")}
					variant="outlined"
					size="large"
					disableRipple
					fullWidth
					sx={{
						height: "60px",
						color: zoullooColors.grey[700],
						borderColor:
							selectedAvailability === "onMission" ? "#fcce03" : zoullooColors.grey[400],
						borderWidth: selectedAvailability === "onMission" ? 2 : 1,
						"&:hover": {
							borderColor:
								selectedAvailability === "onMission"
									? "#fcce03"
									: zoullooColors.grey[700],
							backgroundColor: zoullooColors.grey[100]
						}
					}}
				>
					{t("freelancerOnboardingMyAvailability.onMission")}
				</Button>
			</Grid2>

			{touched && error && !selectedAvailability && (
				<Grid2 size={{ xs: 12 }}>
					<Typography color="error" variant="body1">
						{error}
					</Typography>
				</Grid2>
			)}
		</Grid2>
	);
}
